import { render } from "./InputGroup.vue?vue&type=template&id=35be2809&scoped=true&ts=true"
import script from "./InputGroup.vue?vue&type=script&lang=ts"
export * from "./InputGroup.vue?vue&type=script&lang=ts"

import "./InputGroup.vue?vue&type=style&index=0&id=35be2809&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35be2809"]])

export default __exports__